import type { ReportLocale } from './report-copy';
const en = {
  title: 'Catalogue cover',
  policy: 'Cover policy',
  automatic: 'Automatic provider cover',
  moderator: 'Moderator selected cover',
  none: 'No cover',
  noneHelp: 'Remove the cover and prevent providers from restoring it.',
  source: 'Cover source',
  link: 'Cover link',
  upload: 'Upload image',
  url: 'Public HTTPS image URL',
  add: 'Add cover image',
  uploadHelp:
    'JPEG, PNG or WebP · up to 5 MB. Optimized automatically without cropping. Save your moderation decision to apply the selected cover.',
  uploading: 'Uploading and preparing cover…',
  invalid: 'Choose a JPEG, PNG or WebP image up to 5 MB.',
  processingFailed:
    'This image could not be processed. Choose a still JPEG, PNG or WebP image up to 5 MB.',
  rateLimited: 'Too many uploads. Wait a minute and try again. Your previous cover is retained.',
  uploadFailed: 'Upload failed. Your previous cover is retained. Try again or use a cover link.',
  rights: 'Rights or attribution note (optional)',
  preview: 'Selected catalogue cover preview',
  imageFailed: 'Image could not load. Choose a working image URL.',
  imageReady: 'Image loaded. Ready to save.',
  imageRequired: 'A valid HTTPS image must load before this cover can be saved.',
};
type Copy = { [K in keyof typeof en]: string };
const sk: Copy = {
  title: 'Obálka v katalógu',
  policy: 'Zdroj obálky',
  automatic: 'Automatická obálka od poskytovateľa',
  moderator: 'Obálka vybraná moderátorom',
  none: 'Bez obálky',
  noneHelp: 'Odstrániť obálku a zabrániť jej obnoveniu poskytovateľmi.',
  source: 'Zdroj obálky',
  link: 'Odkaz na obálku',
  upload: 'Nahrať obrázok',
  url: 'Verejná HTTPS adresa obrázka',
  add: 'Pridať obrázok obálky',
  uploadHelp:
    'JPEG, PNG alebo WebP · najviac 5 MB. Automatická optimalizácia bez orezania. Vybraná obálka sa použije po uložení rozhodnutia.',
  uploading: 'Nahrávanie a príprava obálky…',
  invalid: 'Vyberte obrázok JPEG, PNG alebo WebP s veľkosťou najviac 5 MB.',
  processingFailed:
    'Obrázok sa nepodarilo spracovať. Vyberte statický JPEG, PNG alebo WebP s veľkosťou najviac 5 MB.',
  rateLimited:
    'Príliš veľa nahrávaní. Počkajte minútu a skúste znova. Predchádzajúca obálka zostáva zachovaná.',
  uploadFailed:
    'Nahrávanie zlyhalo. Predchádzajúca obálka zostáva zachovaná. Skúste znova alebo použite odkaz.',
  rights: 'Poznámka k právam alebo autorstvu (voliteľná)',
  preview: 'Náhľad vybranej obálky',
  imageFailed: 'Obrázok sa nepodarilo načítať. Vyberte funkčnú adresu obrázka.',
  imageReady: 'Obrázok je načítaný a pripravený na uloženie.',
  imageRequired: 'Pred uložením obálky sa musí načítať platný HTTPS obrázok.',
};
const cs: Copy = {
  title: 'Obálka v katalogu',
  policy: 'Zdroj obálky',
  automatic: 'Automatická obálka od poskytovatele',
  moderator: 'Obálka vybraná moderátorem',
  none: 'Bez obálky',
  noneHelp: 'Odstranit obálku a zabránit jejímu obnovení poskytovateli.',
  source: 'Zdroj obálky',
  link: 'Odkaz na obálku',
  upload: 'Nahrát obrázek',
  url: 'Veřejná HTTPS adresa obrázku',
  add: 'Přidat obrázek obálky',
  uploadHelp:
    'JPEG, PNG nebo WebP · nejvýše 5 MB. Automatická optimalizace bez oříznutí. Vybraná obálka se použije po uložení rozhodnutí.',
  uploading: 'Nahrávání a příprava obálky…',
  invalid: 'Vyberte obrázek JPEG, PNG nebo WebP o velikosti nejvýše 5 MB.',
  processingFailed:
    'Obrázek se nepodařilo zpracovat. Vyberte statický JPEG, PNG nebo WebP o velikosti nejvýše 5 MB.',
  rateLimited:
    'Příliš mnoho nahrávání. Počkejte minutu a zkuste to znovu. Předchozí obálka zůstává zachována.',
  uploadFailed:
    'Nahrávání selhalo. Předchozí obálka zůstává zachována. Zkuste to znovu nebo použijte odkaz.',
  rights: 'Poznámka k právům nebo autorství (volitelná)',
  preview: 'Náhled vybrané obálky',
  imageFailed: 'Obrázek se nepodařilo načíst. Vyberte funkční adresu obrázku.',
  imageReady: 'Obrázek je načtený a připravený k uložení.',
  imageRequired: 'Před uložením obálky se musí načíst platný HTTPS obrázek.',
};
export const COVER_COPY: Record<ReportLocale, Copy> = { en, sk, cs };
